import axiosInstance from './Instance/axiosInstance';
import { Expense } from '../types/expense';

export const getExpenses = async (): Promise<Expense[]> => {
    const res = await axiosInstance.get('/expenses');
    return res.data;
};

export const createExpense = async (data: Omit<Expense, 'id'>): Promise<Expense> => {
    const res = await axiosInstance.post('/expenses', data);
    return res.data;
};

export const updateExpense = async (id: string, data: Omit<Expense, 'id'>): Promise<Expense> => {
    const res = await axiosInstance.put(`/expenses/${id}`, data);
    return res.data;
};

export const deleteExpense = async (id: string): Promise<void> => {
    await axiosInstance.delete(`/expenses/${id}`);
};
